/**
 * Update URL params without reloading the page.
 * 
 * @param {Map<string, string>} params
 */
export function updateUrlParams(params) {
  const search = new URLSearchParams(location.search);
  for (const [name, value] of params.entries()) {
    // This URI-encodes value
    search.set(name, value);
  }
  history.pushState({}, "", `${location.pathname}?${search.toString()}`);
}

/**
 * Update a URL param without reloading the page.
 * 
 * @param {string} name
 * @param {string} value
 */
export function updateUrlParam(name, value) {
  updateUrlParams(new Map([[name, value]]));
}
